import React from 'react'
import "./Full_screen_modal.css"
import { Modal } from 'react-bootstrap';

const Full_screen_modal = ({ lottie, ...props }) => {
    return (
        <>
            <Modal
                {...props}
                fullscreen
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="Fullscreen_Success_Modal"
            >
                <div className="container">
                    <Modal.Body>
                        <div className="full_modal">
                            <div className="success_content_div">
                                <div className="success_card">
                                    {/* <div className="lottie_hold">{lottie}</div> */}
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                </div>
            </Modal>
        </>
    );
};

export default Full_screen_modal